"use strict";

ProjectEconomy = Backbone.Model.extend({
    entity: 'Project',
    urlRoot: Core.contextRoot + '/project/economy/' ,
    
    initialize: function(attributes, options) {
        if (options && options.projectId) this.urlRoot += options.projectId;
    },
})